import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar from '../components/navbar'
import Hero from '../components/hero'
import Aboutus from '../components/aboutus'
import Services from '../components/services'
import Gallery from '../components/gallery'
import Reviews from '../components/reviews'
import Contactus from '../components/contactus'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Evac Towing — Евакуація авто 24/7 у Вінниці та області</title>
        <meta
          name="description"
          content="Цілодобова буксирування авто в Вінниці та області. Швидко, безпечно, без зайвих слів. Evac — коли машина підвела, а ми ні.\n\n"
        />
        <meta
          property="og:title"
          content="Evac Towing — Евакуація авто 24/7 у Вінниці та області"
        />
        <meta
          property="og:description"
          content="Цілодобова буксирування авто в Вінниці та області. Швидко, безпечно, без зайвих слів. Evac — коли машина підвела, а ми ні.\n\n"
        />
        <link rel="canonical" href="https://evac.teleporthq.app/" />
        <meta property="og:url" content="https://evac.teleporthq.app/" />
      </Helmet>
      <Navbar
        link1={
          <Fragment>
            <span className="home-text100">Evac</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text101">Про нас</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text102">Наші послуги</span>
          </Fragment>
        }
        page1={
          <Fragment>
            <span className="home-text103">Home</span>
          </Fragment>
        }
        page2={
          <Fragment>
            <span className="home-text104">Services</span>
          </Fragment>
        }
        page3={
          <Fragment>
            <span className="home-text105">About Us</span>
          </Fragment>
        }
        page4={
          <Fragment>
            <span className="home-text106">Contact</span>
          </Fragment>
        }
        link31={
          <Fragment>
            <span className="home-text107">Контакти</span>
          </Fragment>
        }
        action2={
          <Fragment>
            <span className="home-text108">Зробити виклик</span>
          </Fragment>
        }
        logoSrc="/icons/transparent_1747515030_8617.svg"
        link2Url={{
          url: '#about_us',
          newTab: false,
        }}
        link3Url={{
          url: '#services',
          newTab: false,
        }}
        link3Url1={{
          url: '#contact_us',
          newTab: false,
        }}
        linkUrlPage2={{
          url: '#about_us',
          newTab: false,
        }}
        linkUrlPage3={{
          url: '#colaborationSteps',
          newTab: false,
        }}
        linkUrlPage4={{
          url: '#contacts',
          newTab: false,
        }}
        rootClassName="navbarroot-class-name"
        page1Description={
          <Fragment>
            <span className="home-text109">
              Welcome to Evac - Your 24/7 Towing Partner
            </span>
          </Fragment>
        }
        page2Description={
          <Fragment>
            <span className="home-text110">
              Our Comprehensive Towing Services
            </span>
          </Fragment>
        }
        page3Description={
          <Fragment>
            <span className="home-text111">
              Learn More About Evac Towing Services
            </span>
          </Fragment>
        }
        page4Description={
          <Fragment>
            <span className="home-text112">
              Get in Touch with Evac for Immediate Assistance
            </span>
          </Fragment>
        }
      ></Navbar>
      <Hero
        action21={
          <Fragment>
            <span className="home-text113">Зробити виклик</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text114">
              <span>
                Ми не просто буксируємо авто — ми вирішуємо ситуації. Швидко,
                безпечно, цілодобово.
              </span>
              <br></br>
              <span>
                Великі чи малі, легкі чи складні випадки — ви не самі. Evac
                завжди поруч.
              </span>
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text118">Evac — машина підвела, ми ні!</span>
          </Fragment>
        }
        hero17Id="Hero17"
        image1Src="/content/carousel/photo_1_2025-05-17_22-43-11-1500w.jpg"
        image2Src="/content/carousel/photo_10_2025-05-17_22-43-11-1500w.jpg"
        image3Src="/content/carousel/photo_12_2025-05-17_22-43-11-1500w.jpg"
        image4Src="/content/carousel/photo_11_2025-05-17_22-43-11-1500w.jpg"
        image5Src="/content/carousel/photo_13_2025-05-17_22-43-11-1500w.jpg"
        image6Src="/content/carousel/photo_15_2025-05-17_22-43-11-1500w.jpg"
        image7Src="/content/carousel/photo_17_2025-05-17_22-43-11-1500w.jpg"
        image8Src="/content/carousel/photo_19_2025-05-17_22-43-11-1500w.jpg"
        image9Src="/content/carousel/photo_2_2025-05-17_22-43-11-1500w.jpg"
        image10Src="/content/carousel/photo_21_2025-05-17_22-43-11-1500w.jpg"
        image11Src="/content/carousel/photo_7_2025-05-17_22-43-11-1500w.jpg"
        image12Src="/content/carousel/photo_8_2025-05-17_22-43-11-1500w.jpg"
        rootClassName="heroroot-class-name"
      ></Hero>
      <Aboutus
        content1={
          <Fragment>
            <span className="home-text119">
              <span>
                Ми — компанія з дуже досвідченою командою, яка добре знає, що
                таке справжній сервіс.
              </span>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        content2={
          <Fragment>
            <span className="home-text123">
              <span>
                Evac Towing — це оперативні та професійні послуги евакуації,
                техдопомоги й транспортування автомобілів. 
              </span>
              <span>
                Ми працюємо 24/7, щоб бути на зв’язку у будь-який момент, коли
                вам потрібна підтримка.
              </span>
            </span>
          </Fragment>
        }
        content3={
          <Fragment>
            <span className="home-text126">
              <span>
                Поломка, ДТП, пробите колесо чи інші несподіванки — реагуємо
                швидко й працюємо чітко. 
              </span>
              <span>
                У нашому розпорядженні сучасна техніка й команда, яка не просто
                знає свою справу, а дійсно хоче допомогти.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        content4={
          <Fragment>
            <span className="home-text130">
              <span>
                Маєте автопарк або шукаєте надійного партнера на постійну
                основу?  
              </span>
              <span>
                Ми відкриті до довгострокової співпраці, пропонуючи прозорі
                умови, пунктуальність і сервіс, на який можна покластись.
              </span>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        content5={
          <Fragment>
            <span className="home-text135">
              <span>
                Жодних прихованих платежів чи зайвих обіцянок. Усе чітко,
                зрозуміло та з повагою до кожного клієнта. 
              </span>
              <span>
                Наше головне завдання — зробити так, щоб ви відчули: вам дійсно
                допомогли.
              </span>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text140">Evac - хто ми? І чому саме ми?</span>
          </Fragment>
        }
        heading2={
          <Fragment>
            <span className="home-text141">
              <span>
                Надійна допомога на дорозі — саме тоді, коли вона вам найбільше
                потрібна.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        heading3={
          <Fragment>
            <span className="home-text144">
              <span>Ми допомагаємо в будь-яких ситуаціях.</span>
              <br></br>
            </span>
          </Fragment>
        }
        heading4={
          <Fragment>
            <span className="home-text147">
              <span>Працюємо не тільки з водіями, але й з бізнесом.</span>
              <br></br>
            </span>
          </Fragment>
        }
        heading5={
          <Fragment>
            <span className="home-text150">
              <span>Ми завжди за чесність і відкриту комунікацію.</span>
              <br></br>
            </span>
          </Fragment>
        }
        aboutUsId="about_us"
        aboutUsId1="about_us"
        rootClassName="aboutusroot-class-name"
      ></Aboutus>
      <Services
        steps21Id="Steps21"
        servicesId="services"
        step1Title={
          <Fragment>
            <span className="home-text153">Зателефонуйте нам</span>
          </Fragment>
        }
        step2Title={
          <Fragment>
            <span className="home-text154">Опишіть ситуацію</span>
          </Fragment>
        }
        step3Title={
          <Fragment>
            <span className="home-text155">Зачекайте на підтвердження</span>
          </Fragment>
        }
        step4Title={
          <Fragment>
            <span className="home-text156">Все інше — за нами</span>
          </Fragment>
        }
        rootClassName="servicesroot-class-name1"
        step1Description={
          <Fragment>
            <span className="home-text157">
              Це найшвидший спосіб отримати допомогу. Ми завжди на зв’язку, щоб
              не гаяти ваш час.
            </span>
          </Fragment>
        }
        step2Description={
          <Fragment>
            <span className="home-text158">
              Розкажіть що сталося, де ви знаходитесь і яка складність. Чим
              більше деталей — тим краще ми підготуємось.
            </span>
          </Fragment>
        }
        step3Description={
          <Fragment>
            <span className="home-text159">
              Ми уточнимо всі нюанси, підтвердимо замовлення й одразу вирушимо
              до вас.
            </span>
          </Fragment>
        }
        step4Description={
          <Fragment>
            <span className="home-text160">
              <span>
                Розслабтесь! Приїдемо вчасно,зробимо швидко й професійно.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>Будьте спокійні — ми знаємо, що робимо</span>
            </span>
          </Fragment>
        }
        colaborationStepsId="colaboration_steps"
      ></Services>
      <Gallery
        content1={
          <Fragment>
            <span className="home-text164">
              Ми працюємо не в студії, а на дорозі — ось як це виглядає
              насправді. Наші машини, складні виїзди і моменти, якими пишаємось.
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text165">
              Evac у дії — моменти, якими ми пишаємось.
            </span>
          </Fragment>
        }
        galleryId="gallery"
        image1Src="/content/gallery/photo_14_2025-05-17_22-43-11-1400w.jpg"
        image2Src="/content/gallery/photo_4_2025-05-17_23-09-48-1400w.jpg"
        image3Src="/content/gallery/photo_22_2025-05-17_22-43-11-1400w.jpg"
        image4Src="/content/gallery/photo_4_2025-05-17_22-43-11-1400w.jpg"
        image5Src="/content/gallery/photo_5_2025-05-17_22-43-11-1400w.jpg"
        image6Src="/content/gallery/photo_6_2025-05-17_22-43-11-1400w.jpg"
        rootClassName="galleryroot-class-name"
      ></Gallery>
      <Reviews
        review2={
          <Fragment>
            <span className="home-text166">
              Сервіс просто космос – машину забрали швидше, ніж я встиг сказати
              “ой”. Водій такий ввічливий, що я навіть подумав, може, це
              преміум-таксі, а не евакуатор. Підвіска в моєї ластівки тепер
              відпочила на платформі, як на курорті.
            </span>
          </Fragment>
        }
        review3={
          <Fragment>
            <span className="home-text167">
              Щиро дякую вам за якісну та оперативну евакуацію моєї улюбленої
              автівки. Ваша професійність, відповідальність та швидка реакція
              заслуговують найвищої оцінки. Приємно мати справу з компанією, яка
              ставить комфорт і безпеку клієнтів на перше місце.
            </span>
          </Fragment>
        }
        review4={
          <Fragment>
            <span className="home-text168">
              Сьогодні вперше скористалася послугами евакуатора, і залишилася
              дуже задоволена. Машина раптово заглохла посеред дороги, і
              ситуація здавалася безвихідною. Вже за 25 хвилин евакуатор був на
              місці. Водій — дуже ввічливий і досвідчений, акуратно завантажив
              авто та доставив до СТО без жодних проблем. Все було чітко, швидко
              й за адекватну ціну. Дякую за оперативну допомогу в складній
              ситуації.
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text169">
              <span>
                Реальні відгуки від тих, хто скористався нашими послугами.
              </span>
              <br></br>
              <span className="home-text172">
                Ми працюємо для вас — і ось як клієнти оцінюють наш підхід.
              </span>
              <br className="home-text173"></br>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text176">
              <span>Думки, які мають значення</span>
              <br></br>
            </span>
          </Fragment>
        }
        review11={
          <Fragment>
            <span className="home-text179">
              Швидко та якісно. Дякую за допомогу
            </span>
          </Fragment>
        }
        reviewsId="reviews"
        author1Src="https://images.unsplash.com/photo-1555421689-d68471e189f2?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODY0NHw&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1080"
        author2Src="/reviews/1-200h.png"
        author3Src="/reviews/2-200h.png"
        author4Src="/reviews/3-200h.png"
        author1Src1="/reviews/4-200h.png"
        author2Name={
          <Fragment>
            <span className="home-text180">Dima V.</span>
          </Fragment>
        }
        author3Name={
          <Fragment>
            <span className="home-text181">Anna Kolisnyk</span>
          </Fragment>
        }
        author4Name={
          <Fragment>
            <span className="home-text182">Tatyana Vereschak</span>
          </Fragment>
        }
        author1Name1={
          <Fragment>
            <span className="home-text183">Ivan Perun</span>
          </Fragment>
        }
        rootClassName="reviewsroot-class-name"
      ></Reviews>
      <Contactus
        email1={
          <Fragment>
            <span className="home-text184">info@evac.vn.ua</span>
          </Fragment>
        }
        phone1={
          <Fragment>
            <span className="home-text185">+38 (097) 73-16-850</span>
          </Fragment>
        }
        phone11={
          <Fragment>
            <span className="home-text186">+38 (093) 29-79-737</span>
          </Fragment>
        }
        content2={
          <Fragment>
            <span className="home-text187">
              <span>
                Зв’яжіться з нами будь-яким зручним способом — ми завжди готові
                допомогти вам у найкоротший термін.
              </span>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        content3={
          <Fragment>
            <span className="home-text191">
              <span>Готові до бізнес-партнерства?</span>
              <br></br>
              <span>Надсилаєте листа - ми швидко</span>
              <br></br>
              <span>розглядаємо пропозицію</span>
              <br></br>
            </span>
          </Fragment>
        }
        content5={
          <Fragment>
            <span className="home-text198">Швидко. Надійно. Доступно.</span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text199">Наші контакти</span>
          </Fragment>
        }
        contact16Id="Contact16"
        contactUsId="contact_us"
        rootClassName="contactusroot-class-name"
      ></Contactus>
      <Footer
        text={
          <Fragment>
            <span className="home-text200">Про нас</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="home-text201">Наші послуги</span>
          </Fragment>
        }
        text11={
          <Fragment>
            <span className="home-text202">ВІдгуки</span>
          </Fragment>
        }
        text12={
          <Fragment>
            <span className="home-text203">Блог</span>
          </Fragment>
        }
        logoSrc="/icons/logo.svg"
        text111={
          <Fragment>
            <span className="home-text204">Контакти</span>
          </Fragment>
        }
        textUrl={{
          url: '#about_us',
          newTab: false,
        }}
        content3={
          <Fragment>
            <span className="home-text205">
              © 2026 Evac Towing Service. All Rights Reserved.
            </span>
          </Fragment>
        }
        sendForm={
          <Fragment>
            <span className="home-text206">Надіслати</span>
          </Fragment>
        }
        textUrl1={{
          url: '#services',
          newTab: false,
        }}
        textUrl11={{
          url: '#reviews',
          newTab: false,
        }}
        textUrl12={{
          url: '#gallery',
          newTab: false,
        }}
        textUrl111={{
          url: '#contact_us',
          newTab: false,
        }}
        column1Title={
          <Fragment>
            <span className="home-text207">Evac</span>
          </Fragment>
        }
        rootClassName="footerroot-class-name"
        socialLinkTitle={
          <Fragment>
            <span className="home-text208">Ми у соцмережах</span>
          </Fragment>
        }
      ></Footer>
      <a href="https://play.teleporthq.io/signup" className="home-link">
        <div aria-label="Sign up to TeleportHQ" className="home-container2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 19 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="home-icon1"
          >
            <path
              d="M9.1017 4.64355H2.17867C0.711684 4.64355 -0.477539 5.79975 -0.477539 7.22599V13.9567C-0.477539 15.3829 0.711684 16.5391 2.17867 16.5391H9.1017C10.5687 16.5391 11.7579 15.3829 11.7579 13.9567V7.22599C11.7579 5.79975 10.5687 4.64355 9.1017 4.64355Z"
              fill="#B23ADE"
            ></path>
            <path
              d="M10.9733 12.7878C14.4208 12.7878 17.2156 10.0706 17.2156 6.71886C17.2156 3.3671 14.4208 0.649963 10.9733 0.649963C7.52573 0.649963 4.73096 3.3671 4.73096 6.71886C4.73096 10.0706 7.52573 12.7878 10.9733 12.7878Z"
              fill="#FF5C5C"
            ></path>
            <path
              d="M17.7373 13.3654C19.1497 14.1588 19.1497 15.4634 17.7373 16.2493L10.0865 20.5387C8.67402 21.332 7.51855 20.6836 7.51855 19.0968V10.5141C7.51855 8.92916 8.67402 8.2807 10.0865 9.07221L17.7373 13.3654Z"
              fill="#2874DE"
            ></path>
          </svg>
          <span className="home-text209">Built in TeleportHQ</span>
        </div>
      </a>
    </div>
  )
}

export default Home
